export default {
  data() {
    return {
      arrayNameOfTheItem: null,
      itemToBeDeleted: null
    }
  },
  methods: {
    close(dialogName, formName) {
      this[dialogName] = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1

        if (formName == 'formLiberacao') {
          this.editedItem.fornecedores = [];
          this.$refs[formName].resetValidation();
        }
        else this.$refs[formName].reset()
      }, 300);
      this.pagination.page = 1;
    },
    editItem(item, arrayName, dialogName) {
      this.editedIndex = this[arrayName].content.findIndex(itemArray => itemArray.id === item.id)
      this.editedItem = Object.assign({}, item);
      
      if(dialogName == 'liberacaoFormDialog'){
        this.editedItem.fornecedores.map(f => {
          if(f.cnpj == null) f.tipo = 'Estrangeiro';
          else f.tipo = 'Jurídico';
        })
      }

      this[dialogName] = true
    },
    openConfirmationDialog(dialogName, arrayName, item) {
      this[dialogName] = true
      this.arrayNameOfTheItem = arrayName
      this.itemToBeDeleted = item
    },
    closeConfirmationDialog(dialogName) {
      this[dialogName] = false
      this.arrayNameOfTheItem = null
      this.itemToBeDeleted = null
    },
    deleteItem(payload) {
      this.$store.dispatch('delete', {
        loaderName: payload.loaderName,
        service: payload.service,
        editedContent: payload.newContent,
        getService: payload.getService,
        itemName: payload.itemName
      });
      this.pagination.page = 1;
    },
    async save(payload) {
      this.loadingSave = true;
      if (payload.formName == 'formLiberacao'){
        payload.newContent.fornecedores = await payload.newContent.fornecedores.map(f => {
          return f.id;
        })
      }

      if (this.editedIndex > -1) {
        if (this.$refs[payload.formName].validate()) {
          if (payload.formName == 'formLiberacao') delete payload.newContent.logs;
          
          await this.$store.dispatch('edit', {
            loaderName: payload.loaderName,
            service: payload.service,
            editedContent: payload.newContent,
            getService: payload.getService,
            itemName: payload.itemName
          });
          await payload.closeFunction()
        }
        this.loadingSave = false;
      } else {
        if (this.$refs[payload.formName].validate()) {
          await this.$store.dispatch('new', {
            loaderName: payload.loaderName,
            service: payload.service,
            newContent: payload.newContent,
            getService: payload.getService,
            itemName: payload.itemName
          });
          await payload.closeFunction();
        }
        this.loadingSave = false;
      }
    }
  }
}